import EventEmitter from "../classes/EventEmitter.js";
import { wait } from "../classes/Utils.js";
import autorenew from "@icons/autorenew.svg";

export default class Loader extends EventEmitter {
  loaderElement: HTMLElement;
  parent: HTMLElement;
  active: boolean;
  text: string;
  /*
    The Loader is used to mask a certain container and ad an loading symbol.

    Usage:
    Take note that all parameters are OPTIONAL
    Loader.init(
      element: The element that needs to be covered
      active: Is the loader active from start
      text: Add a String as loading text
    )

  */

  init(element: HTMLElement, active: boolean, text: string) {
    let loaderHtml = `
    <div class="loader-holder">
      <div class="loader-holder__spinner">
        <div class="ma-icon large spin">
          ${autorenew}
        </div>
      </div>
      <h3>${text}</h3>
    </div>`;

    this.parent = element;
    this.active = active;

    if (text) {
      this.text = text;
    } else {
      this.text = "";
    }

    this.loaderElement = document.createElement("div");
    this.loaderElement.classList.add("loader");
    this.loaderElement.innerHTML = loaderHtml;
    this.parent.style.position = "relative";

    this.parent.appendChild(this.loaderElement);

    this.show();
    return this;
  }

  error(text: string) {
    let svg = `<?xml version="1.0" encoding="UTF-8"?>
    <svg width="51px" height="47px" viewBox="0 0 51 47" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Group-2">
                <g id="triage">
                    <path d="M19.5173787,3.48893887 L0.927860246,36.2276762 C0.3439084,37.2372614 0,38.4534595 0,39.7494853 C0,43.6399104 3.09979182,46.7931034 6.9243302,46.7931034 C6.92586894,46.7931034 19.3081101,46.7931034 44.0710536,46.7931034 C47.9002082,46.7931034 51,43.6399104 51,39.7494853 C51,38.4534595 50.6560916,37.2372614 50.0536749,36.194806 L31.5010862,3.52180909 C30.2962527,1.40168002 28.0804671,0 25.541546,0 C22.9195329,2.08532989e-15 20.7037473,1.40402789 19.5173787,3.48893887 Z" id="Path" fill="#040404"></path>
                    <g id="Group" transform="translate(4.115688, 4.647160)" fill="#FCC200">
                        <path d="M9.87189616,19.5823731 C9.86742843,19.5823731 9.86117361,19.5823731 9.85581233,19.5823731 C8.87291174,19.5823731 8.01510758,20.1260941 7.55582494,20.9334924 L0.35920549,33.6118292 C0.133138353,34.0027991 0,34.4737815 0,34.9756778 C0,36.4822759 1.20003227,37.703375 2.68063799,37.703375 C2.68153153,37.703375 2.68153153,37.703375 2.68242508,37.703375 L17.0613672,37.703375 C17.0622608,37.703375 17.0622608,37.703375 17.0631543,37.703375 C18.5437601,37.703375 19.7437923,36.4822759 19.7437923,34.9756778 C19.7437923,34.4737815 19.610654,34.0027991 19.3774385,33.5990999 L12.1951158,20.9462217 C11.7286847,20.1251848 10.8708806,19.5823731 9.88797999,19.5823731 C9.88261871,19.5823731 9.87636389,19.5823731 9.87100262,19.5823731 L9.87189616,19.5823731 Z" id="Shape"></path>
                        <path d="M18.866773,1.35111936 L11.6701536,14.0294561 C11.4440864,14.420426 11.3109481,14.8914084 11.3109481,15.3933047 C11.3109481,16.8999028 12.5109804,18.121002 13.9915861,18.121002 C13.9921818,18.121002 18.7857582,18.121002 28.3723153,18.121002 C29.8547081,18.121002 31.0547404,16.8999028 31.0547404,15.3933047 C31.0547404,14.8914084 30.9216021,14.420426 30.6883865,14.0167269 L23.5060638,1.36384862 C23.0396328,0.54281175 22.1818287,0 21.1989281,0 C20.1838598,8.07560606e-16 19.3260557,0.543720982 18.866773,1.35111936 Z" id="Shape-Copy"></path>
                        <path d="M32.4937923,19.5823731 C32.4893246,19.5823731 32.4830698,19.5823731 32.4777085,19.5823731 C31.4948079,19.5823731 30.6370037,20.1260941 30.1777211,20.9334924 L22.9811017,33.6118292 C22.7550345,34.0027991 22.6218962,34.4737815 22.6218962,34.9756778 C22.6218962,36.4822759 23.8219284,37.703375 25.3025342,37.703375 C25.3034277,37.703375 25.3034277,37.703375 25.3043212,37.703375 L39.6832634,37.703375 C39.684157,37.703375 39.684157,37.703375 39.6850505,37.703375 C41.1656562,37.703375 42.3656885,36.4822759 42.3656885,34.9756778 C42.3656885,34.4737815 42.2325501,34.0027991 41.9993346,33.5990999 L34.8170119,20.9462217 C34.3505809,20.1251848 33.4927767,19.5823731 32.5098762,19.5823731 C32.5045149,19.5823731 32.4982601,19.5823731 32.4928988,19.5823731 L32.4937923,19.5823731 Z" id="Shape"></path>
                    </g>
                </g>
                <path d="M10,11 L42,41" id="Line" stroke="#F51E1E" stroke-width="11"></path>
                <path d="M42,11 L10,41" id="Line" stroke="#F51E1E" stroke-width="11"></path>
            </g>
        </g>
    </svg>`;

    this.parent.querySelector(".loader-holder__spinner").innerHTML = svg;
    this.parent.querySelector(".loader-holder__text").innerHTML = text;
  }

  show() {
    this.loaderElement.style.display = "flex";
    this.parent.style.overflow = "hidden";
  }

  hide() {
    this.loaderElement.classList.add("loader-hidden");

    wait(500).then(() => {
      this.loaderElement.style.display = "none";
      this.parent.style.overflow = "auto";
    });
  }
}
